import { styled } from '@mui/material';
import Box from '@mui/material/Box';

const RepresentativesTabStyledContainer = styled(Box)`
  width: 100%
  display: flex;
  position: relative;
  gap: 40px;

  .representative-tab-button {
    max-width: none;
    text-align: center;
    height: 45px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 5px 50px;
    border-radius: 8px;
	margin-top: 10px;

    color: ${({ theme }) => theme.palette.secondary.main};
  }
`;

export { RepresentativesTabStyledContainer };
